import PRODUCTION from "@/common/config";

const state = {
  user: {}
};

const getters = {
  user: state => state.user,
  loggedIn: state => state.user.id !== undefined
};

const actions = {
  initAuth({ commit }) {

    const userId = PRODUCTION
      ? parseInt(window.__LWDATA__)
      : 1;

    if (userId) {
      commit("setUser", { id: userId });
    }
  }
};

const mutations = {
  setUser: (state, user) => (state.user = user)
};

export default {
  state,
  getters,
  actions,
  mutations
};
